import * as formWizardConstants from './constants';

/**
 * Gets an array of next buttons in an element (e.g. form or panel)
 *
 * @param {Element} element
 */
export default function getNextButtons(element) {
  if (!element) return [];
  return Array.from(element.querySelectorAll(formWizardConstants.selectors.nextButton));
}
